function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, computed, onMounted } from "vue";
import { getMessageList } from "@pt/api/message";
import axios from "axios";
import WarrantMessageEnter from "./enter.vue";
import WarrantMessageList from "./list.vue";
import WarrantMessageDialog from "./dialog.vue";
import { Unread } from "@pt/api/message/enum";
import _ from "lodash";
export default defineComponent({
    components: {
        WarrantMessageEnter: WarrantMessageEnter,
        WarrantMessageList: WarrantMessageList,
        WarrantMessageDialog: WarrantMessageDialog
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var updateMessageList = function updateMessageList(msg_id) {
            warrantMessageList.value.forEach(function(x) {
                if (x.msg_id === msg_id) {
                    x.status = Unread.Read;
                }
            });
        };
        var visible = ref(false);
        var loading = ref(false);
        var dialogVisible = ref(false);
        var dialogData = ref();
        var warrantMessageList = ref([]);
        var badge = computed(function() {
            return warrantMessageList.value.filter(function(t) {
                return t.status === Unread.Send;
            }).length;
        });
        var ListCancelToken = axios.CancelToken;
        var listSource = null;
        function getWarrantMessageList() {
            return _getWarrantMessageList.apply(this, arguments);
        }
        function _getWarrantMessageList() {
            _getWarrantMessageList = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res, last_pop_up;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loading.value = true;
                            if (listSource) {
                                listSource.cancel("cancel request");
                                setTimeout(function() {
                                    loading.value = true;
                                }, 0);
                            }
                            listSource = ListCancelToken.source();
                            _ctx.next = 5;
                            return getMessageList({
                                cancelToken: listSource.token
                            }).finally(function() {
                                loading.value = false;
                            });
                        case 5:
                            res = _ctx.sent;
                            last_pop_up = _.get(res, "data.data.last_pop_up") || null;
                            warrantMessageList.value = (res.data.data.list || []).map(function(t) {
                                return _objectSpreadProps(_objectSpread({}, t), {
                                    show: false
                                });
                            });
                            if (!_.isNull(last_pop_up) && last_pop_up.is_pop_up === 1) {
                                dialogData.value = last_pop_up;
                                dialogVisible.value = true;
                            }
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getWarrantMessageList.apply(this, arguments);
        }
        onMounted(function() {
            getWarrantMessageList();
        });
        return {
            visible: visible,
            badge: badge,
            loading: loading,
            dialogData: dialogData,
            dialogVisible: dialogVisible,
            warrantMessageList: warrantMessageList,
            updateMessageList: updateMessageList
        };
    }
});
